import { render, staticRenderFns } from "./RecordDocumentationCard.vue?vue&type=template&id=09740b04&scoped=true"
import script from "./RecordDocumentationCard.vue?vue&type=script&lang=js"
export * from "./RecordDocumentationCard.vue?vue&type=script&lang=js"
import style0 from "./RecordDocumentationCard.vue?vue&type=style&index=0&id=09740b04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09740b04",
  null
  
)

export default component.exports